import { AxiosInstance } from 'axios';
import snakeCase from 'lodash/snakeCase';
import baseAxios from '@/helpers/forms/axios';
import { PickDataResponse, PickResponse, orderInterface, pickDataInterface, pickInterface, toPickData, toPick } from '../orders';

export interface pickDataRequestInterface {
    type: string
    skipped: boolean
    code: string | null
}

export default (axios: AxiosInstance = baseAxios): { assignPicks: (orders: Array<Pick<orderInterface, 'id'>>) => Promise<void>; markAsPicked: (picks: pickInterface[]) => Promise<pickInterface[]>; assignPicksByPriority: (ordersToPickQuantity: number) => Promise<void>; updatePickData: (orderItemId: number, data: pickDataRequestInterface) => Promise<pickDataInterface>; printPickList: () => Promise<string>; } => ({
    assignPicks: async (orders: Array<Pick<orderInterface, 'id'>>): Promise<void> => {
        return await axios.post('/api/orders/assignPicksBySelected', { orders });
    },

    markAsPicked: async (picks: pickInterface[]): Promise<pickInterface[]> => {
        const response = await axios.post<{ picks: PickResponse[] }>('/api/orders/batch/markAsPicked', { picks });

        return response.data.picks.map(toPick);
    },

    assignPicksByPriority: async (ordersToPickQuantity: number): Promise<void> => {
        return await axios.post('/api/orders/assignPicksByPriority', { orders_to_pick_quantity: ordersToPickQuantity });
    },

    updatePickData: async (orderItemId: number, data: pickDataRequestInterface): Promise<pickDataInterface> => {
        data.type = snakeCase(data.type);
        const requestData: Record<string, unknown> = { type: data.type, skipped: data.skipped };
        if (data.code !== null) {
            requestData.code = data.code;
        }

        const response = await axios.post<{ pick_data: PickDataResponse }>(`/api/order-items/${orderItemId}/scan`, requestData);

        return toPickData(response.data.pick_data);
    },

    printPickList: async (): Promise<string> => {
        const response = await axios.get<{ url: string }>('/api/orders/pickList');

        return response.data.url;
    },
});
